import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  from_referral: false
};

const upgradePopupSlice = createSlice({
  name: "upgradePopup",
  initialState,
  reducers: {
    openUpgradePopup: (state, action) => {
      state.isOpen = true;
      state.from_referral = action.payload?.from_referral || false;
      state.requiredSubscription = action.payload?.requiredSubscription || 0;
    },
    closeUpgradePopup: (state) => {
      state.isOpen = false;
      state.from_referral = false;
    },
    setFromReferral: (state, action) => {
      state.from_referral = action.payload;
    }
  }
});

export const { openUpgradePopup, closeUpgradePopup, setFromReferral } = upgradePopupSlice.actions;
export default upgradePopupSlice.reducer;